import React from "react";
import { DateTimeDisplay } from "../../components/ui";

const Documentation = () => (
    <main>
        <div className="container mb-2">
            <section className='page'>
                <h2 className="heading__dashboard">Documentation</h2>
                <DateTimeDisplay />
            </section>
        </div>
    </main>
);

export default Documentation;